"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
var React = require("react");
var Column = /** @class */ (function (_super) {
    __extends(Column, _super);
    function Column(props) {
        return _super.call(this, props) || this;
    }
    Column.prototype.render = function () {
        return (React.createElement("div", { className: "column", style: Object.assign({}, { display: 'flex', flexDirection: 'column', flex: 1 }, // A row is a row anyway
            this.props.justifyContent ? { justifyContent: this.props.justifyContent } : {}, this.props.alignItems ? { alignItems: this.props.alignItems } : {}, this.props.alignSelf ? { alignSelf: this.props.alignSelf } : {}, this.props.width ? { width: this.props.width } : {}) }, this.props.children));
    };
    return Column;
}(React.Component));
exports.Column = Column;
